/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

export type TransactionRefundValue = {
  success: boolean | null;
  errorMessage: string;
  transactionId: string;
};

type HookProps = {
  api: vp.Api;
  bearer: string;
};

type ReturnTuple = [TransactionRefundValue, (transactionId: string) => void, () => void];

function useTransactionRefund({ api, bearer }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [transactionId, setTransactionId] = useState('');
  const [response, setResponse] = useState<TransactionRefundValue>({ success: null, errorMessage: '', transactionId });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async () => {
      setDataFetchingInfo(true, 'refunding transaction', 'fullScreen');

      const { Success, ErrorMessage } = await api.postTransactionRefund(
        { TransactionID: transactionId },
        bearer,
        source,
      );

      setResponse({ success: Success, errorMessage: ErrorMessage, transactionId });
      setSendRequest(false);
      setDataFetchingInfo(false);
    };

    if (shouldSendRequest) void sendRequest();

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (id: string) => {
      setTransactionId(id);
      setSendRequest(true);
    },
    () => {
      setTransactionId('');
      setResponse({ success: null, errorMessage: '', transactionId: '' });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useTransactionRefund);
